import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@du/ui/fontes.css'
import '@du/ui/tokens.css'
import '@du/ui/componentes.css'
import './global.css'
import { App } from './App.js'
import { ProvedorSessao } from './lib/sessao.js'

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </BrowserRouter>
  </StrictMode>,
)
